import { render, staticRenderFns } from "./StudentDidYouKnow.vue?vue&type=template&id=0706c860&scoped=true"
import script from "./StudentDidYouKnow.vue?vue&type=script&lang=js"
export * from "./StudentDidYouKnow.vue?vue&type=script&lang=js"
import style0 from "./StudentDidYouKnow.vue?vue&type=style&index=0&id=0706c860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0706c860",
  null
  
)

export default component.exports